import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { HeliosHttpRequests } from '../../models/http.model'

@Injectable({
  providedIn: 'root',
})
export class HttpRecorderService {
  readonly recordedHttpRequests$: Subject<HeliosHttpRequests> = new Subject()
}
